import { useCallback, useEffect, useRef } from "react";
import useUnmount from "../ui/useUnmount";

export default function FaviconProvider({ href }) {
  const lastIcon = useRef("");

  const getIconNode = useCallback(() => {
    return document.head.querySelector("link[rel='icon']");
  }, []);

  // Favicon updates look to require a full removal and re-addition for the
  // update to occur. react-helmet does not seem to do this properly.
  const updateIcon = useCallback(
    (newHref) => {
      if (newHref) {
        getIconNode().remove();
        const newNode = document.createElement("link");
        newNode.setAttribute("rel", "icon");
        newNode.setAttribute("href", newHref);
        document.head.appendChild(newNode);
      }
    },
    [getIconNode]
  );

  useEffect(() => {
    lastIcon.current = getIconNode().getAttribute("href");
    updateIcon(href);
  }, [getIconNode, updateIcon, href]);

  useUnmount(
    useCallback(() => {
      updateIcon(lastIcon.current);
    }, [updateIcon])
  );

  return null;
}
